import React from "react";
import {
  FaArrowRightLong,
  FaBuildingShield,
  FaClipboardList,
  FaFileCircleCheck,
  FaGavel,
  FaScaleBalanced
} from "react-icons/fa6";
import NaicsComplianceCheckerVariant from "../components/NaicsComplianceCheckerVariant";
import "../styles/NaicsRulesVariantPage.css";

function NaicsRulesVariant() {
  return (
    <main className="naics-rules-exp-page">
      <section className="naics-exp-hero">
        <div className="naics-exp-wrap">
          <p className="naics-exp-label">Experimental Page</p>
          <h1>Rules and Regulations by NAICS Code</h1>
          <p className="naics-exp-subtitle">
            Type a NAICS code and instantly get agencies, regulations, registrations, permits,
            documents, and first actions for U.S. food-industry compliance.
          </p>

          <div className="naics-exp-flow">
            <div className="naics-exp-step">
              <span>1</span>
              Enter a 6-digit NAICS code
            </div>
            <FaArrowRightLong className="naics-exp-arrow" />
            <div className="naics-exp-step">
              <span>2</span>
              Review rules and required actions
            </div>
            <FaArrowRightLong className="naics-exp-arrow" />
            <div className="naics-exp-step">
              <span>3</span>
              Use links and checklist to execute
            </div>
          </div>
        </div>
      </section>

      <section className="naics-exp-wrap naics-exp-insights">
        <div className="naics-exp-card">
          <h3>
            <FaBuildingShield /> Who Regulates You
          </h3>
          <p>See the primary agencies involved for your NAICS class.</p>
        </div>
        <div className="naics-exp-card">
          <h3>
            <FaScaleBalanced /> Which Rules Apply
          </h3>
          <p>Get the core federal and state compliance regulations to follow.</p>
        </div>
        <div className="naics-exp-card">
          <h3>
            <FaFileCircleCheck /> What You Must File
          </h3>
          <p>Review required registrations, permits, and documentation.</p>
        </div>
        <div className="naics-exp-card">
          <h3>
            <FaClipboardList /> What To Do Next
          </h3>
          <p>Start with a practical action sequence built for your category.</p>
        </div>
        <div className="naics-exp-card">
          <h3>
            <FaGavel /> Compliance Focus
          </h3>
          <p>Built to make regulation review faster and easier to understand.</p>
        </div>
      </section>

      <section className="naics-exp-wrap naics-exp-checker">
        <NaicsComplianceCheckerVariant />
      </section>
    </main>
  );
}

export default NaicsRulesVariant;
